import axios from 'axios';

const httpClient = axios.create({
  baseURL:"https://digihelp.acuitysoftware.in/admin/api"
  // baseURL: "https://acuitysoftware.co/digi-help-app/api", // Replace with your actual base URL
});

export default httpClient;